import React, { memo } from 'react';
import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/react';
import GrCardV2 from '../../../../components/cards/grandRound/grCardV2/GrCardV2';

const SpecialityContentSlider = ({
  specialityId,
  specialityTitle,
  contentArray,
  exploreMoreClick,
  isContentPage = false
}) => {
  // const exploreMoreClick = () => {};
  const _id = () => {
    if (specialityTitle === 'Popular Certified Courses') {
      return 'training_landing_popular';
    } else if (specialityTitle === 'Completed Certified Courses') {
      return 'training_landing_complete';
    } else if (specialityTitle === 'Related Certified Courses') {
      return 'trainning_content_related_trainning';
    } else {
      return 'training_landing_incomplete';
    }
  };
  return contentArray?.length > 0 ? (
    <div className="w-100 float-start cmnLandingSlideRow mt-5" id={_id()}>
      <div className="d-flex justify-content-between align-items-baseline">
        <h2 className="text-black fs-3 fw-semibold">{specialityTitle}</h2>
        {contentArray?.length > 2 && (
          <a
            href="javascript:void(0)"
            className={`text-primary rippleEffect fs-4 fw-medium text-nowrap ${specialityTitle == 'Popular Certified Courses'
                ? 'gtm_cl_trainnig_landing_popular_certified_courses_explore_more'
                : specialityTitle == 'Incomplete Certified Courses'
                  ? 'gtm_cl_trainnig_landing_incomplete_certified_courses_explore_more'
                  : 'gtm_cl_trainnig_landing_completed_certified_courses_explore_more'
              }`}
            onClick={() => exploreMoreClick && exploreMoreClick()}
            // id={
            //   specialityTitle == 'Related Certified Courses'
            //     ? 'trainning_content_related_trainning_explore_more'
            //     : 'defaultRelatedTrainning_explore_more'
            // }
            id={
              specialityTitle == 'Popular Certified Courses'
                ? 'trainnig_landing_popular_certified_courses_explore_more'
                : specialityTitle == 'Incomplete Certified Courses'
                  ? 'trainnig_landing_incomplete_certified_courses_explore_more'
                  : 'trainnig_landing_completed_certified_courses_explore_more'
            }
          >
            Explore More
          </a>
        )}
      </div>
      <div className="cmnLndngRowSlidePrrnt">
        <Swiper
          className="cmnLndngRowSlide"
          spaceBetween={24}
          slidesPerView={3}
          loop={false}
          breakpoints={{
            1: {
              slidesPerView: 1,
              spaceBetween: 10
            },
            640: {
              slidesPerView: 1,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 22
            },
            992: {
              slidesPerView: isContentPage ? 2 : 3,
              spaceBetween: 24
            },
            1400: {
              slidesPerView: isContentPage ? 3 : 4,
              spaceBetween: 26
            }
          }}
        >
          {contentArray?.length > 0 &&
            contentArray?.map((_training, index) => (
              <SwiperSlide
                className={_training?.is_completed == 100 ? 'grCardCompleted' : ''}
                key={index + 1}
              >
                <GrCardV2 data={_training} gtmTagVariable="trainnig_landing" />
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </div>
  ) : null;
};

export default memo(SpecialityContentSlider);
